import store from '@/store';
import APIService, { setAppCookie } from '@/api';

import {
  IRouterMiddleware,
  MiddlewareRoute,
  MiddlewareCallback,
} from '../middleware.interface';
import { getSignUpUrlRoutes } from '@/views/Onboarding/helpers';
import { isExternalOauthSessionOnline } from '../router-utils';
import flagKeys from '@/constants/flagKeys';

class BusinessOnboardingRedirect {
  constructor(
    private readonly to: MiddlewareRoute,
    private readonly from: MiddlewareRoute,
    private readonly next: MiddlewareCallback,
  ) {}

  get flags() {
    return store.getters['flags/getFlags'] || [];
  }

  execute() {
    const { name } = this.to;

    const prefixSignup = getSignUpUrlRoutes();

    // TODO: add this when physical business onboarding is enabled (JUST FOR NOT BLOCKING TESTS)
    // if (
    //   this.flags.includes(flagKeys.physicalBusinessOnboardingQ12026) &&
    //   !isExternalOauthSessionOnline()
    // ) {
    //   setAppCookie('instore');

    //   window.location.reload();
    //   return;
    // }

    if (name === 'bo-your-digital-coin' && !isExternalOauthSessionOnline()) {
      // TODO: REMOVE THIS WHEN PHYSICAL BUSINESS ONBOARDING IS ENABLED
      if (this.flags.includes(flagKeys.physicalBusinessOnboardingQ12026)) {
        setAppCookie('instore');

        window.location.reload();
      } else {
        this.next(prefixSignup.YOUR_BUSINESS);
      }

      return;
    }

    if (APIService.token && name === 'bo-your-account') {
      this.next(prefixSignup.YOUR_BUSINESS);

      return;
    }

    this.next();
  }
}

export class HandleBusinessOnboardingRedirect implements IRouterMiddleware {
  canActivate(to: MiddlewareRoute) {
    return (
      to.matched.some((route) => route.name === 'business-onboarding') ||
      to.path.includes('/business-setup')
    );
  }

  async execute(
    to: MiddlewareRoute,
    from: MiddlewareRoute,
    next: MiddlewareCallback,
  ): Promise<void> {
    const instance = new BusinessOnboardingRedirect(to, from, next);
    instance.execute();
  }
}
